export default angular
    .module('westBerkshireEvents.noClickFocus')
    .directive('noClickFocus', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind("mousedown", function(e) {
                    e.stopImmediatePropagation(); //stops event bubbling    
                    e.preventDefault();  //stops default browser action (focus)
                });
            }
        }
    }]);


// WEBPACK FOOTER //
// src/public/javascripts/no-click-focus/no_click_focus.directive.js